// Angular imports
import { Directive, HostListener } from '@angular/core';

// 3rd party imports
import { OptionChangedEvent } from 'devextreme/ui/data_grid';

// CC-Common imports
import { Utils } from 'cc-common';

// Service imports
import { UserService } from '../../_services/data-services/user.service';

@Directive({
    selector: '[appHasInternalUserColumns]'
})
export class HasInternalUserColumnsDirective {
    columnNames = [
        'InternalNotes',
        'InternalLogs',
        'ProjectLogs',
        'InternalDashboardStatus',
        'InternalActions',
        'InternalDashboardResponsible',
        'InternalInspector',
        'InternalFinalOverride',
        'InternalReviewRequested',
        'InternalReviewDate',
        'InternalReviewNote',
        'InternalClosedReason',
        'InternalClosedBy',
        'InternalActive',
        'InternalApproved',
        'InternaW9',
        'InternalBranchActive',
        'InternalBranchApproved',
        'InternalGlobalActive',
        'InternalGlobalApproved',
        'InternalTaxId',
        'InternalVisibleOnResidentPortal',
        'InternalCorporateUseOnly',
        'InternalBoardMembers',
        'InternalFullfillment',
        'InternalPortalUserName',
        'InternalLastLogin',
        'InternalAllowBoard',
        'InternalBusinessRoles',
        'InternalDepartments',
        'InternalUploadedBy',
        'InternalVisibleOnBoardPortal'
    ];

    constructor(private readonly userService: UserService) {}

    @HostListener('onInitialized', ['$event'])
    onInitialized(event: any): void {
        this.filterColumnForNonInternalUser(event);
    }

    @HostListener('onOptionChanged', ['$event'])
    onOptionChanged(event: OptionChangedEvent): void {
        // On columns count changed
        if (
            Utils.notNullAndDefined(event) &&
            Utils.equalsIgnoreCase(event.name, 'columns') &&
            Utils.equalsIgnoreCase(event.fullName, 'columns') &&
            Array.isArray(event.value) &&
            Array.isArray(event.previousValue)
        ) {
            const previousColumnsCount = event.previousValue.length;
            const currentColumnsCount = event.value.length;
            if (Utils.notEquals(previousColumnsCount, currentColumnsCount)) {
                this.filterColumnForNonInternalUser(event);
            }
        }
    }

    private filterColumnForNonInternalUser(event: any): void {
        if (!this.userService.isInternal()) {
            let columns = event.component.option('columns');
            if (Utils.isTrue(event.component.option('stateStoring').enabled)) {
                const state = event.component.state() || {};
                columns = state.columns || columns;
            }
            columns.forEach((c) => {
                if (Utils.isInList(c.name, this.columnNames)) {
                    c.visible = c.showInColumnChooser = false;
                }
            });
        }
    }
}
